export * from './post-feld-unterkategorie-request.interface';
export * from './post-feld-unterkategorie-response.interface';
export * from './post-feld-unterkategorie.shapes';
